// Canonical design tokens for phase 6. Mirrored as CSS custom properties in
// web/src/styles/tokens.css and consumed by antd via ThemeProvider.

export type ThemeTokens = {
  brand: string;
  brand2: string;
  brandSoft: string;
  brandInk: string;
  accent: string;
  accentSoft: string;
  highlight: string;

  bg: string;
  paper: string;
  surface: string;
  surface2: string;
  surface3: string;
  pageBg: string;

  ink: string;
  ink2: string;
  ink3: string;
  inkSoft: string;
  rule: string;
  ruleStrong: string;
  ruleSoft: string;
  sage: string;
  sageSoft: string;
  colorWarningText: string;
  colorLink: string;

  shadowSm: string;
  shadow: string;

  t2xs: string;
  t3xl: string;
  t4xl: string;

  navH: string;
  railH: string;
  chatW: string;
  colMax: string;
};

export const lightTokens: ThemeTokens = {
  brand: "#B1D137",
  brand2: "#9aba2c",
  brandSoft: "#f0f5de",
  brandInk: "#5C7118",
  accent: "#757A7B",
  accentSoft: "#ececec",
  highlight: "#B1D137",

  bg: "#FAFAFA",
  paper: "#FFFFFF",
  surface: "#ffffff",
  surface2: "#f5f5f5",
  surface3: "#ebebeb",
  pageBg: "#f3f4ef",

  ink: "#000000",
  ink2: "#333333",
  ink3: "#696d6d",
  inkSoft: "#a8abac",
  rule: "#e6e6e6",
  ruleStrong: "#cfcfcf",
  ruleSoft: "#EEEFEF",
  sage: "#7A8F5E",
  sageSoft: "#E8EDDF",
  colorWarningText: "#d48806",
  colorLink: "#1677ff",

  shadowSm: "0 1px 2px rgba(20,30,20,0.05)",
  shadow:
    "0 1px 3px rgba(20,30,20,0.05), 0 12px 28px -16px rgba(20,30,20,0.18)",

  t2xs: "10.5px",
  t3xl: "52px",
  t4xl: "84px",

  navH: "56px",
  railH: "88px",
  chatW: "360px",
  colMax: "920px",
};

export const darkTokens: ThemeTokens = {
  brand: "#C4E04C",
  brand2: "#B1D137",
  brandSoft: "#2a3318",
  brandInk: "#A3C42E",
  accent: "#9a9d9e",
  accentSoft: "#2a2a2a",
  highlight: "#B1D137",

  bg: "#0e0e0e",
  paper: "#161616",
  surface: "#161616",
  surface2: "#1d1d1d",
  surface3: "#262626",
  pageBg: "#161616",

  ink: "#f0f0f0",
  ink2: "#c2c2c2",
  ink3: "#898989",
  inkSoft: "#5b5b5b",
  rule: "#2a2a2a",
  ruleStrong: "#3a3a3a",
  ruleSoft: "#222222",
  sage: "#8FA872",
  sageSoft: "#1E2518",
  colorWarningText: "#d89614",
  colorLink: "#4096ff",

  shadowSm: "0 1px 2px rgba(0,0,0,0.4)",
  shadow:
    "0 1px 3px rgba(0,0,0,0.4), 0 12px 28px -16px rgba(0,0,0,0.6)",

  t2xs: "10.5px",
  t3xl: "52px",
  t4xl: "84px",

  navH: "56px",
  railH: "88px",
  chatW: "360px",
  colMax: "920px",
};

export function tokensFor(effective: "light" | "dark"): ThemeTokens {
  return effective === "dark" ? darkTokens : lightTokens;
}
